document.addEventListener("DOMContentLoaded", function () {
  /**
   * Gokwik's sidecart is often rendered inside a Shadow DOM.
   * We use a main observer to find the shadow host, and a nested observer
   * to watch for dynamic content changes inside the shadow root.
   */

  const mainObserver = new MutationObserver((mutations, obs) => {
    const shadowHost = document.querySelector("shadow-dom-container");

    if (shadowHost && shadowHost.shadowRoot) {
      const root = shadowHost.shadowRoot;

      // 1. Inject Styles
      if (!root.querySelector("#gokwik-custom-styles")) {
        applyCustomStyles(root);
      }

      // 2. Initial processing
      injectFreeProductBanner(root);

      // 3. Attach a nested observer to the shadowRoot for dynamic updates
      if (!root._nestedObserverAttached) {
        const nestedObserver = new MutationObserver(() => {
          injectFreeProductBanner(root);
        });
        nestedObserver.observe(root, { childList: true, subtree: true });
        root._nestedObserverAttached = true;
      }
    }
  });

  mainObserver.observe(document.body, { childList: true, subtree: true });
});

/**
 * Injects the custom Free Product banner.
 * Fetches the image URL from a global variable (set via Shopify metafield).
 */
function injectFreeProductBanner(shadowRoot) {
  // Target containers to try (Gokwik occasionally changes selectors)
  const targetSelectors = [".sidecart-footer", ".side-cart-content-wrapper"];
  let targetWrapper = null;
  
  for (const selector of targetSelectors) {
    targetWrapper = shadowRoot.querySelector(selector);
    if (targetWrapper) break;
  }
  
  if (!targetWrapper) return;

  // Prevent duplicate injection
  if (shadowRoot.querySelector("#custom-free-product-banner")) return;

  // Fetch image URL from metafield (with fallback)
  const bannerImageUrl = window.gokwikCartBannerUrl || "https://cdn.shopify.com/s/files/1/0605/7977/6049/files/free-product.png?v=1744336340";

  const newbanner = document.createElement("div");
  newbanner.id = "custom-free-product-banner";
  newbanner.innerHTML = `
   
  `;

  targetWrapper.prepend(newbanner);
}

/**
 * Injects custom CSS rules into the Gokwik shadow root.
 */
function applyCustomStyles(shadowRoot) {
  const style = document.createElement("style");
  style.id = "gokwik-custom-styles";

  style.textContent = `
    .sidecart .free-product {
      background-color: #fff9f1 !important;
    }
    .free-product-image {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      gap: 8px !important;
    }
    .free-product-image img {
      width: 100% !important;
      height: auto !important;
    }
    
    
    .scroll-container {
      overflow-x: auto !important;
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
    }
    .scroll-container::-webkit-scrollbar {
      display: none !important;
    }

    .scroll-container .card {
      min-width:7rem !important;
    }

      .scroll-container .card .product-name{
      max-width:8rem !important;
      font-size:12px !important;
      }

      .scroll-container .card .price{
      display:flex !important;
      flex-direction:column !important;
      gap:3px !important;
    }

       .scroll-container .card .product-image{
       min-height:100% !important;
    }

     .scroll-container .card .discount-banner {
     display:none !important;
    }

      .scroll-container .card .price > br{
      display:none !important;
    }

      .scroll-container .card .price > br{
      display:none !important;
    }

      .scroll-container .card .price > span{
      order:-1 !important;
    }

    .scroll-container .card .add-btn {
       width:100% !important;
      font-size: 0 !important; 
      background-color: #000 !important;
      color:white !important;
      border-color:black !important;
    }

    .add-to-cart{
    background-color: #000 !important;
      color:white !important;
      border-color:black !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }

    .scroll-container .card .add-btn::after {
       content:'Add to Cart' !important;
       font-size: 12px !important;
    }

    .offer-box {
    display:none !important;
    }
        

  `;

  shadowRoot.appendChild(style);
}